import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SearchBodyWrapper, SearchInputWrap, SearchBtnClose } from './style';

// components
import SearchInput from './SearchInput';
import SearchUsersList from './SearchUsersList';

// icons
import { Icon } from '../../Components/Icons/Icons';
import { SearchUsersActionCreators } from '../../../Store/ActionCreators/SearchUsersActionCreators';

class SearchBody extends Component {
    static propTypes = {
        handleClose: PropTypes.func.isRequired,
        // from connect
        users: PropTypes.array.isRequired,
        offset: PropTypes.number.isRequired,
        offsetFollowers: PropTypes.number.isRequired,
    };

    state = {
        filterText: '',
    };

    handleCloseSearch = () => {
        this.inputNode.value = '';
        this.props.handleClose();
    };

    handleScroll = () => {
        const { filterText } = this.state;
        const { getMoreUsers, offset, offsetFollowers } = this.props;

        getMoreUsers(filterText, offset, offsetFollowers);
    };

    handleChangeInput = filter => {
        if (filter) {
            this.props.getAllUsers(filter);
            return this.setState({ filterText: filter });
        }

        this.props.getAllUsers();
        return this.setState({ filterText: '' });
    };

    getInputNode = node => {
        this.inputNode = node;
    };

    render() {
        const { users, open, offsetFollowers, loading, isLoadAll } = this.props;

        return (
            <SearchBodyWrapper isActive={open}>
                <SearchInputWrap>
                    <SearchInput
                        onChangeInput={value => this.handleChangeInput(value)}
                        getInput={node => this.getInputNode(node)}
                        open={open}
                    />
                    <SearchBtnClose onClick={this.handleCloseSearch}>
                        <Icon.Box size={'14x10'}>
                            <Icon.SearchCloseIcon />
                        </Icon.Box>
                    </SearchBtnClose>
                </SearchInputWrap>
                <SearchUsersList
                    offsetFollowers={offsetFollowers}
                    users={users}
                    isLoadAll={isLoadAll}
                    loading={loading}
                    handleScroll={this.handleScroll}
                    handleClose={this.handleCloseSearch}
                />
            </SearchBodyWrapper>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    getAllUsers: (filter, offset_id) => dispatch(SearchUsersActionCreators.getUsers(filter)),
    getMoreUsers: (filter, offset_id, offset_followers) =>
        dispatch(SearchUsersActionCreators.getMoreUsers(filter, offset_id, offset_followers)),
});

export default connect(
    state => ({
        users: [...state.usersSearch.users],
        offset: state.usersSearch.offset,
        offsetFollowers: state.usersSearch.offsetFollowers,
        isLoadAll: state.usersSearch.isLoadAll,
        loading: state.usersSearch.loading,
    }),
    mapDispatchToProps,
)(SearchBody);



// WEBPACK FOOTER //
// ./src/UI/Containers/Search/SearchBody.js